/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState, useEffect } from 'react'
import './Home.scss'

import logoTitle from '../../assets/svg/logoTitle.svg'
// import logo from '../../assets/svg/logo.svg'
import { Link } from 'react-router-dom'

import { get } from '../../services/https'

import { notify } from '../../components/Toast'

import { ToastContainer } from 'react-toastify'

import ShopCard from '../../components/ShopList/index'

export default function index() {
  const [shops, setShops] = useState([])

  useEffect(() => {
    get('/api/front/shops/')
      .then(response => {
        setShops(response.data.data)
      })
      .catch(error => {
        notify('error', 'دریافت اطلاعات با خطا مواجه شد')
      })
  }, [])

  return (
    <div id='home'>
      <ToastContainer rtl />
      <div className='body'>
      </div>
      <div className='scroll'>
        <div className='title'>
          <img src={logoTitle} style={{ width: '180px' }} alt='logoTitle' />
        </div>
        <div className='subtitle'>
          برای مشاهده منو، لطفا شعبه مورد نظر خود را انتخاب نمایید
        </div>
        <hr />
        <ShopCard data={shops} />
        <div id='copyright'>
          <hr />
          <span className='text'>
            طراحی و توسعه توسط <Link to='https://ham-team.ir'>هم‌تیم</Link> ،  قدرت گرفته از <Link to='https://ibills.ir'>ibills</Link>
          </span>
        </div>
      </div>
      
    </div>
  )
}
